import { Api } from '@/api/api.client';
import { uploadFile } from '@/api/resources/file.api';
import { FileUploadType } from '@/api/generated/api.enum';
import type { Components } from '@/api/generated/api';

export async function updateSchoolClassAppearance(params: {
  schoolClassId: number;
  dto: Components.Schemas.UpdateEntityAppearanceDto;
}): Promise<Components.Schemas.SchoolClassDto> {
  const result = await Api.Routes.EntityAppearance.updateClassAppearance({ id: params.schoolClassId }, params.dto);
  return result.data;
}

export async function uploadSchoolClassImage(params: {
  schoolClassId: number;
  file: File;
}): Promise<Components.Schemas.SchoolClassDto> {
  const uploaded = await uploadFile(FileUploadType.entityAppearanceImage, params.file);
  const result = await Api.Routes.EntityAppearance.setClassImage({ id: params.schoolClassId }, { fileId: uploaded.id });
  return result.data;
}
